import React from "react";
import ResetPassword from "../Auth/reset";
import { Link } from "react-router-dom";

const ResetPage = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="t-title">
        <h1>Restablecer contraseña</h1>
      </div>
      <div className="main">
        <ResetPassword />
        <br />
        <Link className="button button-secondary" to="/login">
          Volver al login
        </Link>
      </div>
    </div>
  );
};

export default ResetPage;
